import { Placement } from 'src/constants/recommendations';
import { ReduxApplicationState } from '../combinedReducer';

export const selectPlacementProducts = (state: ReduxApplicationState, placement: Placement) =>
  state.richRelevance[placement].products;
